import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import Icon from '../components/Icon';
import PageHeading from '../components/PageHeading';
import {useProgress} from '../utils/progress';

const titles = {
  eshleluud: '📖 Илчлэлтийн 22 бүлэг',
  duruud: '📖 Илчлэлтийн 3 дүр',
};
export default function ChapterListPage({kind}) {
  const [search,setSearch] = useState('');
  const progress = useProgress();
  const chapters = Array.from({length:22}, (_,i) => i+1);
  const doneCount = chapters.filter(i => !!progress[`${kind}-${i}`]).length;
  const matches = chapters.filter(i => String(i).includes(search.trim()));
  return <section className="page-shell">
    <PageHeading title={titles[kind] || titles.eshleluud} icon="book"/>
    <div className="list-panel">
      <div className="chapter-tools">
        <label className="search-field"><Icon name="search" size={18}/><span className="sr-only">Хайх...</span><input type="search" inputMode="numeric" value={search} onChange={e => setSearch(e.target.value)} placeholder="Хайх..."/></label>
        <span className="completion-pill"><Icon name="check" size={17}/>{doneCount} / 22</span>
      </div>
      <div className="chapters-grid">{matches.map(i => <Link className={`chapter-card ${progress[`${kind}-${i}`] ? 'chapter-card--done' : ''}`} to={`/${kind}/${i}`} key={i} aria-label={`${i}-р бүлэг`}>
        <span className="chapter-card__copy"><strong>{i}-р бүлэг</strong></span>
        <Icon name={progress[`${kind}-${i}`] ? 'check' : 'right'} size={19}/>
      </Link>)}</div>
    </div>
  </section>;
}
